<template>
  <div>
    <iframe
      ref="myElement"
      frameborder="1"
      :height="`${height}px`"
      width="100%"
      scrolling="no"
      :src="`${VUE_APP_BASE_AUTH_MODULE}/team/form?id=${$route.query.id}&tab=${$route.query.tab || 'internal'}`"
      allow="clipboard-read; clipboard-write"
    />

    <ModalPIN
      id="modal-verify-pin"
      :no-close-on-backdrop="false"
      :no-close-on-esc="false"
      title="Verifikasi PIN"
      description="Mohon verifikasi identitas kamu dengan masukan PIN"
      label-confirm-button="Konfirmasi"
      label-cancel-button="Kembali"
      @on-confirm-button="onUpdate"
      @on-cancel-button="$bvModal.hide('modal-verify-pin')"
    />

    <ModalReqOTP
      id="req-OTP-phone"
      title="Tambah Tim"
      :phone-number="profile.user_phone"
      :partner-id="profile.partner_id"
      :purpose="'team'"
      @on-confirm-button="requestTypeSelected"
    />

    <ModalVerifyOtp
      id="confirm-otp-phone"
      title="Verifikasi Kode OTP"
      :partner-id="profile.partner_id"
      :phone-number="profile.user_phone"
      :request-type="requestType"
      :purpose="'team'"
      label-confirm-button="Konfirmasi"
      @on-cancel-button="$bvModal.show('req-OTP-phone')"
      @on-confirm-button="onCreate"
    />
  </div>
</template>

<script>
import ModalPIN from '@/views/components/modal/ModalPIN.vue'
import ModalReqOTP from '@/views/components/modal/ModalReqOTP.vue'
import ModalVerifyOtp from '@/views/components/modal/ModalVerifyOTP.vue'
import { newAxiosIns } from '@/libs/axios'
import secureLs from '@/libs/secureLs'
import { mapState } from 'vuex'

export default {
  components: { ModalPIN, ModalReqOTP, ModalVerifyOtp },
  data() {
    return {
      height: 0,
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
      teamId: this.$route.query.id,
      payload: {},
      source: null,
      requestType: null,
    }
  },
  computed: {
    ...mapState('dashboard', ['profile']),
  },
  mounted() {
    window.addEventListener('message', event => {
      if (event.origin === this.VUE_APP_BASE_AUTH_MODULE) {
        const {
          type, data, route, source, payload,
        } = event.data

        if (type === 'SET_DIMENSION') {
          this.height = Math.floor(data.height)
        }

        this.source = source
        if (source === 'edit') {
          this.payload = payload
          this.$bvModal.show('modal-verify-pin')
        }

        if (source === 'add') {
          console.log('uu')
          this.payload = payload
          this.$bvModal.show('req-OTP-phone')
        }

        if (route) {
          if (route.startsWith('/talent?tab')) {
            this.$router.replace(route)
            return
          }
          this.$router.push(route)
        }
      }
    })
  },
  methods: {
    async onUpdate() {
      const { data: { usable_token } } = secureLs.getItem('verify')

      const url = '/auth/api/v1/teams'
      const payload = {
        ...this.payload,
        token: usable_token,
      }
      await newAxiosIns.put(url, payload)
        .then(() => {
          this.$router.replace(`/talent?tab=${this.$route.query.tab || 'internal'}`)
          this.$toast_success({ message: 'Team berhasil diubah!' })
        })
        .catch(() => {
          this.$toast_error({ message: 'Team gagal diubah!' })
        })
    },
    async onCreate(value) {
      const payload = {
        ...this.payload,
        verify_otp: {
          token: value.token,
          otp: value.otp,
        },
      }

      const url = '/auth/api/v1/teams'
      await newAxiosIns.post(url, payload)
        .then(() => {
          this.$router.replace(`/talent?tab=${this.$route.query.tab || 'internal'}`)
          this.$toast_success({ message: 'Berhasil menambahkan team. Silahkan verifikasi email!' })
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal menambahkan team.' })
        })
    },
    requestTypeSelected(value) {
      this.requestType = value
      this.$bvModal.show('confirm-otp-phone')
    },
  },
}
</script>
